import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ApiService } from '../../../custom-material/Services/';
import {UserModel, BuildingModel } from '../../Models';
import { globalData } from '../../Models/global.model';

@Component({
  selector: 'main-building-choose',
  templateUrl: './t_building-choose.component.html',
  styleUrls: ['./building-choose.component.less']
})
export class BuildingChooseComponent implements OnInit {


  //array of rubrics, wich contain label and array of buildings
  tree: Array<any> = [];

  //show rubrics ('tree') or directly buildings ('notree')
  treeType:string = '';
 //// currentViewMode:string = 'building';

  //array of rubrics labels selected (all its buildings are selected)
  public selectedRubricList: Array<string> = [];


  //placeholder for search input field
  get searchPlaceholder():string
  {
    switch (this.gd.buildingChooserViewMode) {
      case "building":
        return "Nom d' établissement";
      case "user":
        return "Utilisateur responsable"
      case "town":
        return "Ville, département, pays";
      case "buildingType":
        return "Type d'établissement";
      default :
        return "Rechercher"
    }
  }
  //string in search input field
  filter:string = '';
  //filter building with search input field
  get showedBuilding():Array<BuildingModel>
  {
    if(this.filter=='') return this.gd.buildings;

    let regExpFilter = new RegExp(this.filter, 'i');
    return this.gd.buildings.filter(
      (building:BuildingModel) => regExpFilter.test(building.name));
  }
  //filter rubrics with search input field
  get showedRubrics():Array<any>
  {

    if(this.filter=='') return this.tree

    let regExpFilter = new RegExp(this.filter, 'i');
    return this.tree.filter(
      (rubric) => regExpFilter.test(rubric.label));
  }

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    public gd: globalData) {
      if(this.gd.selectedBuildingsList.length==0)
        this.selectAll();
      if(this.gd.buildingChooserViewMode==null)
        this.viewBy('building');
      else this.viewBy(this.gd.buildingChooserViewMode);
    }


  ngOnInit() {}

  //view all buildings, or classified by rubrics
  viewBy(viewMode)
  {

    //record viewMode
    this.gd.buildingChooserViewMode = viewMode;

    //building simple viewMode
    if(viewMode=='building') {
      this.treeType = 'notree';
      return;
    }

    //rubric tree viewMode
    this.treeType = 'tree';
    this.tree =  [];
    this.gd.buildings.forEach((building:BuildingModel)=>{
      let label:string;
      switch (viewMode) {
        case "user":
          label = building.User.name;
          break;
        case "town":
          label = building.town
          if(building.region) label += '-'+building.region;
          if(building.country) label += '-'+building.country;
          break;
        case "buildingType":
          label = building.BuildingType.name;
          break;
        default:
          label = building.name;
          break;
      }

      //create rubric if not exists
      let index = this.labelExists(label);
      if(index == -1) {
        index = this.tree.push({
          label: label,
          buildings: [],
          opened: false
        });

        index--;
      }

      //fill rubric buildings
      this.tree[index].buildings.push(building);

    });
  }

  //check if rubric with a label exists, return index of this rubric
  labelExists(label):number
  {
    let returnIndex = -1;
    this.tree.forEach((obj, index)=>{
      if(obj.label==label) returnIndex = index;
    });

    return returnIndex;
  }

  fold(rubric)
  {
    rubric.opened = !rubric.opened;
  }

 selectRubric($event, rubric)
  {
    let tmpSelectedBuildingList = this.gd.selectedBuildingsList;

    if($event.ctrlKey) {
      //cliqué avec touche ctrl -> sélection multiple
      let rubricIndex = this.selectedRubricList.indexOf(rubric.label);
      if(rubricIndex > -1) {
        //déjà sélectionné -> retirer
        this.selectedRubricList.splice(rubricIndex, 1);
      } else {
        //non sélectionné -> ajouter
        this.selectedRubricList.push(rubric.label);
      }
    } else {
      //cliqué tout seul
      this.selectedRubricList = [rubric.label];
    }

    tmpSelectedBuildingList = [];
    this.selectedRubricList.forEach((rubLabel)=>{
      let rub = this.tree.filter(r=>r.label==rubLabel)[0];
      rub.buildings.forEach((building:BuildingModel)=>{
        tmpSelectedBuildingList.push(building.id);
      });
    });

    this.gd.selectedBuildingsList = tmpSelectedBuildingList;
  }


  selectBuilding($event, building:BuildingModel)
  {
    let tmpSelectedBuildingList = this.gd.selectedBuildingsList;

    if($event.ctrlKey) {
      //cliqué avec touche ctrl -> sélection multiple
      let buildingIndex = tmpSelectedBuildingList.indexOf(building.id);
      if(buildingIndex > -1) {
        //déjà sélectionné -> retirer
        tmpSelectedBuildingList.splice(buildingIndex, 1);
      } else {
        //non sélectionné -> ajouter
        tmpSelectedBuildingList.push(building.id);
      }
    } else {
      //cliqué tout seul
      tmpSelectedBuildingList = [building.id];
      this.selectedRubricList = [];
    }

    this.gd.selectedBuildingsList = tmpSelectedBuildingList;
  }


  selectAll()
  {
    this.gd.selectedBuildingsList = [];
    this.selectedRubricList = [];
    if(this.treeType=='tree') {
      this.showedRubrics.forEach((rubric)=>{
        this.selectRubric({ctrlKey:true}, rubric)
    });
    } else {
      this.showedBuilding.forEach((building:BuildingModel)=>{
        this.gd.selectedBuildingsList.push(building.id);
      });
    }
  }
  unselectAll()
  {
    this.selectedRubricList = [];
    this.gd.selectedBuildingsList = [];
  }
}
